import { z } from "zod";

import { isNonEmptyString } from "~/utilities/string";

const userIdSchema = z.union([z.string().min(1), z.literal("")]);
const emailSchema = z.union([z.email(), z.literal("")]);

export const clientUserRoleRowSchema = z
  .object({
    id: z.string(),
    user_id: userIdSchema,
    email: emailSchema,
    full_name: z.string().optional(),
    roles: z
      .array(z.string())
      .min(1, { message: "Please select at least one Role" }),
    isInvitation: z.boolean().optional(),
    invitationId: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    const hasUserId = isNonEmptyString(val.user_id);
    const hasEmail = isNonEmptyString(val.email);
    if (!hasUserId && !hasEmail) {
      ctx.addIssue({
        code: "custom",
        message: "Please enter User ID or Email",
        path: ["user_id"],
      });
      ctx.addIssue({
        code: "custom",
        message: "Please enter User ID or Email",
        path: ["email"],
      });
    }
  });

export type ClientUserRoleRow = z.infer<typeof clientUserRoleRowSchema>;
